import { StyledNavLink } from 'components/link/StyledNavLink';
import styled, { css } from 'styled-components';

export const breadcrumbBaseCss = css`
    font-size: 1.4rem;
    font-weight: 500;
`;

export const dirEntryThumbnailCss = css`
    height: auto;
    max-height: 4.8rem;
    width: 4.8rem;
    max-width: 4.8rem;
    margin-right: 1rem;
    flex-shrink: 0;
`;

export const BreadcrumbText = styled(StyledNavLink)`
    ${breadcrumbBaseCss}
    cursor: pointer;
`;

export const BreadcrumbSeparator = styled.span`
    ${breadcrumbBaseCss}
`;

export const FolderIconWrapper = styled.div`
    width: 4.8rem;
    max-width: 4.8rem;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const CellNameText = styled.div`
    min-width: 0;
`;

export const EmptyStateContainer = styled.div`
    height: 50.5rem;
`;
